import {
  useTranslate,
  useApiUrl,
  file2Base64,
  HttpError,
} from "@pankod/refine-core";

import {
  Create,
  Drawer,
  DrawerProps,
  Form,
  FormProps,
  Input,
  InputNumber,
  Radio,
  Select,
  Space,
  ButtonProps,
  Typography,
  Upload,
  Grid,
  getValueFromEvent,
  useSelect,
  //DatePicker,
  SaveButton,
} from "@pankod/refine-antd";

import { DatePicker } from "antd";

import dayjs from "dayjs";
import "dayjs/locale/hu";

import { TOKEN_KEY } from "../../constants";

import {
  normalizeFile,
  mediaUploadMapper,
  getValueProps,
} from "utility/normalize";
import { useApiUpload } from "hooks/upload";
import { statusTypes } from "constants/common";
import moment from "moment";

const { Text } = Typography;

type CreateTendersProps = {
  drawerProps: DrawerProps;
  formProps: FormProps;
  saveButtonProps: ButtonProps;
  initialValues: any;
};

export const CreateTenders: React.FC<CreateTendersProps> = ({
  drawerProps,
  formProps,
  saveButtonProps,
  initialValues,
}) => {
  const t = useTranslate();
  const apiUrl = useApiUrl();
  const breakpoint = Grid.useBreakpoint();
  const { ...uploadProps } = useApiUpload({
    maxCount: 2,
  });

  return (
    <Drawer
      {...drawerProps}
      width={breakpoint.sm ? "500px" : "100%"}
      bodyStyle={{ padding: 0 }}
    >
      <Create
        resource="tenders"
        actionButtons={
          <>
            <SaveButton {...saveButtonProps} style={{ marginRight: 10 }} />
          </>
        }
      >
        <Form
          {...formProps}
          layout="vertical"
          initialValues={{
            ...initialValues,
          }}
          onFinish={(values) => {
            values = { ...values, images: getValueProps(values?.images, "") };
            return formProps.onFinish?.(mediaUploadMapper(values));
          }}
        >
          <Form.Item
            hidden
            label={t("tenders.fields.project")}
            name="project"
            rules={[
              {
                required: true,
                
              },
            ]}
          >
            <Input hidden />
          </Form.Item>
          <Form.Item
            label={t("tenders.fields.name")}
            name="name"
            rules={[
              {
                required: true,
                message: t("defaultValidateMessages.required", {
                  name: "${label}",
                }),
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item label={t("tenders.fields.status")} name="status">
            <Select
              options={Object.values(statusTypes).map((p) => ({
                label: t(`${p.label}`),
                value: p.value,
              }))}
              placeholder={t("buttons.pleaseSelect")}
            />
          </Form.Item>

          <Form.Item label={t("tenders.fields.file")}>
            <Form.Item
              label={t("price_offers.fields.file")}
              name="images"
              normalize={normalizeFile}
              getValueProps={(data) => getValueProps(data, "")}
              valuePropName="fileList"
              noStyle
            >
              <Upload.Dragger
                name="file"
                action={`${apiUrl}/media_objects`}
                headers={{
                  Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}`,
                }}
                listType="picture"
                multiple
                {...uploadProps}
              >
                <p className="ant-upload-text">{t("upload.areaTitle")}</p>
              </Upload.Dragger>
            </Form.Item>
          </Form.Item>

          <Form.Item
            label={t("tenders.fields.date")}
            name="startDate"
            rules={[
              {
                required: true,
                message: t("defaultValidateMessages.required", {
                  name: "${label}",
                }),
              },
            ]}
            initialValue={moment()}
            getValueProps={(value) => ({
              value: value ? moment(value) : moment(),
            })}
          >
            <DatePicker placeholder={t("tenders.fields.date")} />
          </Form.Item>

          <Form.Item
            label={t("tenders.fields.description")}
            name="description"
            rules={[
              {
                required: true,
                message: t("defaultValidateMessages.required", {
                  name: "${label}",
                }),
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label={t("tenders.fields.type")}
            name="type"
            rules={[
              {
                required: true,
                message: t("defaultValidateMessages.required", {
                  name: "${label}",
                }),
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Create>
    </Drawer>
  );
};
